angular.module('LexiconControllers', [])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider
      //lexicon
      .when('/lexicon', {
        templateUrl: '/ng1/www/modules/lexicon/html/home.html',
        controller: 'LexiconHomeCtrl'
      });
  }
  ])
  .run(['secondNavbar', 'nbModules', 'EXAM', function(secondNavbar, nbModules, EXAM){
    if (!(EXAM === 'lerobert' || EXAM === 'delf')) {
      nbModules.addModules(1);
      secondNavbar.addModules("Glossaire", "/lexicon", 5);
    }
  }
  ]);
